import React, { useEffect, useRef } from 'react';

export const HomePageParallax = ({ headerImages }) => {
  const getImage = (alt) => headerImages?.find((img) => img.alt === alt)?.imageUrl ?? '';

  const mobile1Ref = useRef(null);
  const mobile2Ref = useRef(null);
  const mobile3Ref = useRef(null);
  const mobile4Ref = useRef(null);
  const desktop1Ref = useRef(null);
  const desktop2Ref = useRef(null);
  const desktop3Ref = useRef(null);
  const desktop4Ref = useRef(null);

  useEffect(() => {
    let ticking = false;

    const updateTransforms = () => {
      const scrollY = window.scrollY;
      if (mobile1Ref.current) mobile1Ref.current.style.transform = `translate(-50%, ${scrollY * -0.05}px)`;
      if (mobile2Ref.current) mobile2Ref.current.style.transform = `translate(-50%, ${scrollY * -0.075}px)`;
      if (mobile3Ref.current) mobile3Ref.current.style.transform = `translate(-50%, ${scrollY * -0.1}px)`;
      if (mobile4Ref.current) mobile4Ref.current.style.transform = `translate(-50%, ${scrollY * -0.15}px)`;
      if (desktop1Ref.current) desktop1Ref.current.style.transform = `translateY(${scrollY * -0.1}px)`;
      if (desktop2Ref.current) desktop2Ref.current.style.transform = `translateY(${scrollY * -0.2}px)`;
      if (desktop3Ref.current) desktop3Ref.current.style.transform = `translateY(${scrollY * -0.3}px)`;
      if (desktop4Ref.current) desktop4Ref.current.style.transform = `translateY(${scrollY * -0.2}px)`;
      ticking = false;
    };

    const handleScroll = () => {
      if (!ticking) {
        requestAnimationFrame(updateTransforms);
        ticking = true;
      }
    };

    updateTransforms();
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const parallaxStyle = { willChange: "transform" };

  return (
    <>
      <div className="absolute left-0 bottom-0 w-full h-full overflow-hidden mt-12 lg:mt-0 pointer-events-none">
        <img
          ref={mobile1Ref}
          style={parallaxStyle}
          className="absolute left-[53%] bottom-[-16px] w-[413px] max-w-none opacity-90 z-[1] lg:hidden"
          src={getImage('homepage-parallax-mobile-1')}
        />
        <img
          ref={mobile2Ref}
          style={parallaxStyle}
          className="absolute left-[53%] bottom-[-15px] w-[413px] max-w-none opacity-80 z-[2] lg:hidden"
          src={getImage('homepage-parallax-mobile-2')}
        />
        <img
          ref={mobile3Ref}
          style={parallaxStyle}
          className="absolute left-[53%] bottom-[-15px] w-[413px] max-w-none opacity-80 z-[3] lg:hidden"
          src={getImage('homepage-parallax-mobile-3')}
        />
        <img
          ref={desktop1Ref}
          style={parallaxStyle}
          className="shrink-0 w-auto h-[720px] absolute right-[calc(50%+180px)] xl:right-[calc(50%+350px)] bottom-0 hidden lg:block"
          src={getImage('homepage-parallax-1')}
        />
        <img
          ref={desktop2Ref}
          style={parallaxStyle}
          className="absolute right-[calc(50%+250px)] xl:right-[calc(50%+420px)] bottom-[30px] hidden lg:block"
          src={getImage('homepage-parallax-2')}
        />
        <img
          ref={desktop3Ref}
          style={parallaxStyle}
          className="absolute w-[140px] right-[calc(50%+180px)] xl:right-[calc(50%+350px)] bottom-[100px] hidden lg:block"
          src={getImage('homepage-parallax-3')}
        />
      </div>

      <img
        ref={desktop4Ref}
        style={parallaxStyle}
        className="w-[268px] h-auto absolute right-[calc(50%+100px)] xl:right-[calc(50%+260px)] bottom-[-110px] hidden lg:block pointer-events-none z-10"
        src={getImage('homepage-parallax-4')}
      />
      <img
        ref={mobile4Ref}
        style={parallaxStyle}
        className="w-[179px] h-auto absolute left-1/2 bottom-[-72px] lg:hidden z-[5] pointer-events-none drop-shadow-[0_8px_22px_rgba(0,28,75,0.42)]"
        src={getImage('homepage-parallax-mobile-4')}
      />

      <div className="relative w-full lg:w-1/2 xl:flex-1 z-10 h-[120px] lg:h-full" />
    </>
  );
}
